<script lang="tsx">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AppHeader',
})
</script>
<!--
 * @Description: file content
 * @Author:
 * @Date: 2023-08-22 11:43:41
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2025-10-09 14:52:01
-->
<script lang="tsx" setup name="AppHeader">
import { computed } from 'vue'
import { getFeedNotReadCount } from '../api'
import { SIDEBAR_INACTIVE_ROUTE } from '../helpers/constant'
import { isBrandEnterprise } from '../app-menu/asideMenu'
import PublishDemand from './PublishDemand.vue'
import WorkspaceSelect from './WorkspaceSelect.vue'
import UserDropInfo from './UserDropInfo.vue'
import { useAppStore, useWorkspaceStore } from '@/store'

import { openWindowWithWorkspace } from '@/utils/tool'

const route = useRoute()

const router = useRouter()

const appStore = useAppStore()
const workspaceStore = useWorkspaceStore()
const workspaceName = computed(() => workspaceStore.currentWorkspace.workspaceName)
const isPersonal = computed(() => workspaceStore.isPersonal)
const workspaceId = computed(() => workspaceStore.currentWorkspace.workspaceId as number)
// 企业id，如果url上有携带enterpriseId且不为-1，则用enterpriseId，如没有enterpriseId则用workspaceId
const enterpriseId = computed(() => (route.query.enterpriseId && Number(route.query.enterpriseId) !== -1) ? Number(route.query.enterpriseId) : workspaceId.value)

const isSidebarCollapsed = computed(() => appStore.isSidebarCollapsed)
// 不显示页面名称 （工作台,首页）
const isShow = false // computed(() => route.name !== 'WorkbenchView' && route.name !== 'HomeView')
// 页面名称
const pageTitle = computed(() => {
  const matched = route.matched
  if (matched.length === 0) {
    return ''
  }

  return matched[matched.length - 1].meta?.title || ''
})

// 返回工作台
function goHome() {
  if (route.name === 'WorkbenchView' || route.name === 'HomeView') {
    return
  }
  router.push('/workbench')
}

// 消息通知
const notifyValue = ref(0)
const notifyLoading = ref(false)
function getNotifyCount() {
  if (notifyLoading.value) {
    return
  }
  notifyLoading.value = true
  getFeedNotReadCount<number>({ enterpriseId: enterpriseId.value, readType: 0 }).then((res) => {
    notifyValue.value = res
  }).finally(() => {
    notifyLoading.value = false
  })
}
getNotifyCount()
// 10s轮询一次
const timer = setInterval(() => {
  getNotifyCount()
}, 10000)
onUnmounted(() => {
  if (timer) {
    // 清除定时器
    clearInterval(timer)
  }
})
function notifyHandle() {
  if (route.name === 'NotifyView') {
    router.replace({
      query: { ...route.query, t: Date.now() },
    })
  } else {
    openWindowWithWorkspace(`/notify?t=${Date.now()}`)
  }
}

const showInviteCompanyMemberModal = ref(false)
// 邀请企业成员
function onInviteMember() {
  showInviteCompanyMemberModal.value = true
}

// 消息通知悬浮后重新定位到有新消息的tab
const messageNotifyRef = ref()
function updateShow(value: boolean) {
  if (value && messageNotifyRef.value) {
    messageNotifyRef.value.init()
  }
}

// 套餐升级
function openPackage() {
  window.open(`https://materialdb.zhaoyl.com/fed/report/%E7%BE%8E%E4%B8%9A%E9%A2%9C%E7%A9%B6%E9%99%A2-AI%20Cowork%E4%BC%81%E4%B8%9A%E7%89%88%E5%A5%97%E9%A4%90%E4%BB%B7%E6%A0%BC.pdf?t=${Date.now()}`)
}

const customerProposalPageNames = computed(() => {
  const arr = ['CustomerProposalDetail', 'CustomerProposalPpt', 'CustomerProposalArchive', 'CustomerProposalAgent', 'ProposalLibrary']
  if (!isBrandEnterprise(workspaceStore.enterpriseTypes)) {
    arr.push('Knowledge')
  }
  return arr
})

const isCustomerProposalPage = ref(customerProposalPageNames.value.includes(route.name as string))
watch(() => route.name, (newVal) => {
  console.log(newVal, 'newVal route.name')
  if (customerProposalPageNames.value.includes(newVal as string)) {
    isCustomerProposalPage.value = true
  } else {
    isCustomerProposalPage.value = false
  }
})
</script>

<template>
  <header class="app-header">
    <div class="header-content">
      <div class="header-left" :class="{ collapsed: isSidebarCollapsed }">
        <template v-if="!isCustomerProposalPage">
          <div v-if="SIDEBAR_INACTIVE_ROUTE.includes(route.name as string)" class="logo-new" />
          <div class="workbench-text" />
        </template>
        <template v-else>
          <div class="proposal-app-header">
            <!-- {{ companyName }} {{ companyMission }} -->
          </div>
        </template>
      </div>
      <div class="header-right flex flex-1 justify-between">
        <div class="flex flex-1 items-center justify-end">
          <!-- 发布需求 -->
          <PublishDemand />
          <WorkspaceSelect />
          <!-- <div class="package-upgrade" @click="openPackage">
            套餐升级
          </div> -->
          <div class="notify-wrap">
            <!-- <NBadge :value="notifyValue" :max="99">
              <div class="notify-btn flex items-center justify-center"
                :data-ph-capture-attribute-page-actions="$getPosthogPath(['顶部导航栏', '消息列表'])" @click="notifyHandle">
                <div class="notify-icon" />
              </div>
            </NBadge> -->
            <NPopover class="system-message-notify-poper" trigger="hover" placement="bottom" raw :show-arrow="false"
              display-directive="show" :duration="500" @update:show="updateShow">
              <!-- <NPopover class="system-message-notify-poper" trigger="manual" :show="2 > 1" :x="1200" placement="bottom"
              raw :show-arrow="false"> -->
              <template #trigger>
                <NBadge :value="notifyValue" :max="99">
                  <div class="notify-btn flex items-center justify-center"
                    :data-ph-capture-attribute-page-actions="$getPosthogPath(['顶部导航栏', '消息列表'])" @click="notifyHandle">
                    <div class="notify-icon" />
                  </div>
                </NBadge>
              </template>
              <MessageNotify ref="messageNotifyRef" />
            </NPopover>
          </div>
          <UserDropInfo @invite-member="onInviteMember" />

          <!-- 加入企业邀请链接 -->
          <InviteCompanyMemberModal v-model="showInviteCompanyMemberModal" />
        </div>
      </div>
    </div>
  </header>
  <!-- 过期消息卡片 -->
  <ExpireCards />
</template>

<style lang="scss">
.system-message-notify-poper {
  box-shadow: none !important;
}

.app-header {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    background: #FFFFFF;
    border-bottom: 1px solid #f2f2f2;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 12px 0 12px;
    transition: padding 0.3s ease-in-out;

    &.collapsed {
      padding: 0 12px 0 24px;
    }

    .proposal-app-header {
      font-size: 15px;
      font-weight: 600;
      color: #ff4080;
    }

    .logo-new {
      width: 121px;
      height: 42px;
      background-size: cover;
      background-image: url("./icons/logo-new-2.png");
    }

    .workbench-text {
      width: 404px;
      height: 22px;
      background: url("./icons/workbench-text.png") no-repeat;
      background-size: contain;
    }
  }

  .header-right {
    padding: 0 20px 0 12px;
    display: flex;
    align-items: center;
    // min-width: 800px;

    .user {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      // border: 1px solid transparent;
      border-radius: 50%;

      &:hover {
        // border-color: #425AFF;
      }
    }

    .package-upgrade {
      margin-right: 20px;
      padding: 6px 12px;
      background: linear-gradient(270deg, #FFCF88 0%, #FFE4AD 100%);
      border-radius: 20px;
      font-weight: 500;
      font-size: 14px;
      color: #894509;
      line-height: 20px;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }

    .notify-wrap {
      position: relative;
      margin-right: 20px;

      .notify-btn {
        width: 32px;
        height: 32px;
        border-radius: 90px;
        cursor: pointer;

        &:hover {
          background: #E8EFFD;
        }
      }

      .notify-icon {
        width: 32px;
        height: 32px;
        background: url('./icons/notify-icon.png') no-repeat;
        background-size: contain;
      }
    }
  }
}

.apply-popover {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  background: linear-gradient(180deg, #FDFEFF 0%, #FFFFFF 100%);
  box-shadow: 0px 8px 12px 0px rgba(202, 207, 227, 0.57);
  border-radius: 4px;
  font-size: 12px;
  color: var(--color--main);
  line-height: 14px;

  .img {
    width: 118px;
    height: 118px;
    margin-bottom: 12px;
  }
}
</style>
